import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useUserInfo } from '../../Authentication/hooks'
import NavigationComponent from '../navigationComponent'
import {
  customPostRequest,
  fetchUserSubscription,
  validateCollegeCategoryData,
  createNavigationHandlers,
  handleAsyncError
} from './utils/categoryUtils'
import '../../../assets/stylesheets/kategories.css'

const CollegeCategory = () => {
  const [collegeName, setCollegeName] = useState('')
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [colleges, setColleges] = useState([])
  const { userId } = useUserInfo()
  const [message, setMessage] = useState('')
  const navigate = useNavigate()
  const [categoryCreated, setCategoryCreated] = useState(false)
  const API_GATEWAY_URL = process.env.REACT_APP_API_GATEWAY_URL
  const [showUpgradeLink, setShowUpgradeLink] = useState(false)

  const { handleHomeClick, handleUploadClick, handleSubscribeClick } =
    createNavigationHandlers(navigate)

  const handleCreate = async () => {
    if (!userId) {
      setMessage('User not authenticated')
      setShowUpgradeLink(false)
      return
    }

    if (!collegeName || !fromDate || !toDate) {
      setMessage('Please enter college name and both start and end dates')
      setShowUpgradeLink(false)
      return
    }

    try {
      const subscriptionData = await fetchUserSubscription(
        userId,
        API_GATEWAY_URL
      )
      if (!subscriptionData) {
        setMessage('Failed to fetch subscription data')
        setShowUpgradeLink(true)
        return
      }

      const { categoryCount, categoryLimit } = subscriptionData

      console.log('Subscription Data:', categoryCount + 1, categoryLimit)
      if (categoryCount >= categoryLimit) {
        setMessage('You have reached your category limit.')
        setShowUpgradeLink(true)
        return
      }
    } catch (error) {
      const errorMessage = handleAsyncError(error, 'fetching category count')
      setMessage(`Failed to fetch category count: ${errorMessage}`)
      setShowUpgradeLink(true)
      return
    }

    const categoryData = {
      userId: userId,
      name: collegeName,
      type: 'education',
      subType: 'college',
      calendarAttrs: {
        fromDate: fromDate + 'T00:00:00Z',
        toDate: toDate + 'T23:59:59Z'
      }
    }

    if (!validateCollegeCategoryData(categoryData, setMessage)) {
      return
    }

    try {
      const apiURL = `${process.env.REACT_APP_API_GATEWAY_URL}/k1/users/${userId}/categories`
      const responseData = await customPostRequest(apiURL, categoryData)

      if (responseData.error) {
        throw new Error(responseData.error)
      }

      setColleges(prev => [...prev, { collegeName, fromDate, toDate }])
      setCollegeName('')
      setFromDate('')
      setToDate('')
      setMessage('Category created successfully!')
      setCategoryCreated(true)
    } catch (error) {
      const errorMessage = handleAsyncError(error, 'creating category')
      setMessage(`Failed to create category: ${errorMessage}`)
    }
  }

  return (
    <div className="college-category">
      <NavigationComponent handleHomeClick={handleHomeClick} />
      <h2 className="category-header">College</h2>
      {message && <p className="message">{message}</p>}
      {showUpgradeLink && (
        <p>
          Please{' '}
          <span className="link-like" onClick={handleSubscribeClick}>
            upgrade
          </span>{' '}
          your plan.
        </p>
      )}
      {message === 'Category created successfully!' && (
        <p>
          <Link to="/gallery">Click here</Link> to return to the main gallery.
        </p>
      )}
      <input
        type="text"
        placeholder="College Name"
        value={collegeName}
        onChange={e => setCollegeName(e.target.value)}
        className="input-field"
      />
      <input
        type="date"
        value={fromDate}
        onChange={e => setFromDate(e.target.value)}
        className="input-field"
      />
      <input
        type="date"
        value={toDate}
        onChange={e => setToDate(e.target.value)}
        className="input-field"
      />
      <div className="button-group">
        <button onClick={handleCreate} className="create-button">
          Create
        </button>
      </div>
      {categoryCreated && (
        <div className="list_and_upload">
          <ul>
            {colleges.map((college, index) => (
              <li
                className="added-list"
                key={`${college.collegeName}-${college.fromDate}-${college.toDate}`}
              >
                {college.collegeName} - {college.fromDate} to {college.toDate}
              </li>
            ))}
          </ul>
          <button className="upload-button-list" onClick={handleUploadClick}>
            Upload Photos
          </button>
        </div>
      )}
    </div>
  )
}

export default CollegeCategory
